import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumoDetalharRoutingModule } from './consumo-detalhar-routing.module';
import { ConsumoDetalharComponent } from './consumo-detalhar.component';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ConsumoDetalharComponent
  ],
  imports: [
    CommonModule,
    ConsumoDetalharRoutingModule,
    FormsModule,
    ButtonModule,
    TableModule,
    DividerModule,
    MessagesModule,
    ProgressSpinnerModule
  ]
})
export class ConsumoDetalharModule { }
